var _defs, _rect, _use, _use2, _pattern, _rect2, _circle, _circle2, _path, _g, _text, _text2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wave1",
    d: "M0 50                          C100 30, 200 70, 300 50                          C400 30, 500 70, 600 50                         V400 H0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wave2",
    d: "M0 70                          C100 50, 200 90, 300 70                          C400 50, 500 90, 600 70                         V400 H0 Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "#F8FAFC"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#wave1",
    fill: "#4F46E5",
    opacity: 0.05
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#wave2",
    fill: "#EC4899",
    opacity: 0.05
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "smallGrid",
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 0 L 0 0 0 10",
    fill: "none",
    stroke: "#4F46E5",
    strokeWidth: 0.5,
    opacity: 0.1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#smallGrid)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 100,
    fill: "white",
    style: {
      filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 90,
    fill: "none",
    stroke: "#4F46E5",
    strokeWidth: 1,
    strokeDasharray: "4 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 80,
    fill: "none",
    stroke: "#EC4899",
    strokeWidth: 1,
    opacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 150            C210 150, 220 160, 220 170            C220 180, 210 190, 190 190            C170 190, 180 210, 190 210            C200 210, 210 220, 210 230            C210 240, 200 250, 190 250            M195 140 V260",
    stroke: "#4F46E5",
    strokeWidth: 8,
    strokeLinecap: "round",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 200) rotate(45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -70,
    cy: 0,
    r: 6,
    fill: "#EC4899"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#EC4899"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 0,
    r: 6,
    fill: "#EC4899"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -70,
    y1: 0,
    x2: 0,
    y2: 0,
    stroke: "#EC4899",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 70,
    y2: 0,
    stroke: "#EC4899",
    strokeWidth: 2
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 80,
    fontFamily: "Arial",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#1E293B",
    textAnchor: "middle"
  }, "\n    Pricing\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 110,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#6B7280",
    textAnchor: "middle"
  }, "\n    Plans for every learning journey\n  ")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 340,
    r: 4,
    fill: "#4F46E5",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 340,
    r: 4,
    fill: "#4F46E5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 340,
    r: 4,
    fill: "#4F46E5",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 340,
    r: 4,
    fill: "#4F46E5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 340,
    r: 4,
    fill: "#4F46E5",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingBanner);
export default __webpack_public_path__ + "static/media/pricing-banner.d11b996d43908cab22f9e47c10c3473d.svg";
export { ForwardRef as ReactComponent };